export interface IAsset {
    toString(): string;
}

export interface AssetLocationInfo {
    readonly skinFullName: string;
    readonly serverPath: string;
    readonly configurationPath: string;
}
export class Asset implements IAsset {
    constructor(private _relativePath: string, private _brandsOverrides: { [key: string]: boolean }) {
    }


    private _locationInfo: AssetLocationInfo;

    resolveLocation(locationInfo: AssetLocationInfo): string {
        this._locationInfo = locationInfo;
        return this.toString();
    }

    toString(): string {
        if(!this._locationInfo) { // this is for the asset to work on unit testing time
            return this._relativePath;
        }

        if (this._brandsOverrides[this._locationInfo.skinFullName]) {
            return this._locationInfo.configurationPath + 'assets/' + this._relativePath;
        }

        return this._locationInfo.serverPath + 'assets/' + this._relativePath;
    }
}
